import { omit } from 'lodash';

import { CheckReadonlyStringArray } from '../../utility.types';
import { BASE_QUERY_PARAMS, FIELDS } from '../constants';
import { AnyRecord } from '../createRoutineSlice';

import {
    BaseQueryParams,
    EnhancedState,
    EnhancedStateWithoutQueryParams,
} from './createEnhancedRoutineSlice.types';

/**
 * A function to enhance state with pagination props
 */
const addPagination = <S extends AnyRecord>(initialState: S): EnhancedState<S> => ({
    ...initialState,
    [FIELDS.LOADING]: !!initialState.loading,
    [FIELDS.META]: initialState.meta || {},
    [FIELDS.QUERY_PARAMS]: {
        ...BASE_QUERY_PARAMS,
        ...initialState[FIELDS.QUERY_PARAMS],
    },
});

const withoutQueryParams = <S extends AnyRecord, E extends ReadonlyArray<keyof BaseQueryParams>>({
    state,
    without,
}: {
    state: S;
    without: CheckReadonlyStringArray<E>;
}) => {
    const withPagination = addPagination(state);
    return {
        ...withPagination,
        [FIELDS.QUERY_PARAMS]: omit(withPagination[FIELDS.QUERY_PARAMS], without),
    } as unknown as EnhancedStateWithoutQueryParams<EnhancedState<S>, E[number]>;
};

export default Object.assign(addPagination, { withoutQueryParams });
